module.exports = __webpack_public_path__ + "static/media/home-header.522d5ed8.png";